import {
  faRoad,
  faBan,
  faMotorcycle,
  faCircleCheck,
  faHandHoldingDollar,
  faBinoculars,
} from "@fortawesome/free-solid-svg-icons";
const carddata = [
  {
    id: 1,
    title: "Serviced Bikes",
    icon: faMotorcycle,
  },
  {
    id: 2,
    title: "No hidden Costs",
    icon: faBan,
  },
  {
    id: 3,
    title: "Unlimited Kilometers",
    icon: faRoad,
  },
  {
    id: 4,
    title: "On Time Services",
    icon: faCircleCheck,
  },
  {
    id: 5,
    title: "Best Price Garuntee",
    icon: faHandHoldingDollar,
  },
  {
    id: 6,
    title: "Insider Travel Guidance",
    icon: faBinoculars,
  },
];

export default carddata;
